<div class="container">
  <div class="row my-3">
    <div class="col-lg-4 col-12">
      <fgb-fantasy-game-panel
        [game]="game$ | async"
        (button)="confirmSelection()"
        [buttonState]="button"
        [horizontal]="false"
      ></fgb-fantasy-game-panel>
    </div>
    <div class="col-lg-8 col-12">
      <div class="d-none d-lg-block">
        <div class="row">
          <div class="col-3" *ngFor="let player of players$ | async">
            <div class="card rounded overflow-hidden mb-3 border" (click)="select(player.PlayerId)">
              <img alt="Player Picture" class="card-img-top border-bottom w-100" src="{{ player.Image | contentImage : '7' }}" />
              <div
                class="card-body d-flex justify-content-start align-items-center"
                [ngClass]="{ 'bg-primary text-white': player.IsSelected, 'text-black bg-white': !player.IsSelected }"
              >
                <div class="mx-auto mb-0 font-size-12 text-capitalize">{{ player.PlayerName }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="d-grid gap-4 mt-4 player-list d-lg-none">
        <div class="card border rounded overflow-hidden px-0" *ngFor="let player of players$ | async">
          <div class="d-flex flex-column" (click)="select(player.PlayerId)">
            <div
              class="ps-0 pe-0 border-end"
              [ngClass]="{ 'bg-primary text-white': player.IsSelected, 'text-black bg-white': !player.IsSelected }"
            >
              <img alt="Player Picture" class="w-100" src="{{ player.Image | contentImage : '7' }}" />
            </div>
            <div
              class="d-flex align-items-center justify-content-center py-2"
              [ngClass]="{ 'bg-primary text-white': player.IsSelected, 'text-black bg-white': !player.IsSelected }"
            >
              <div class="mb-0 font-size-12 text-capitalize">{{ player.PlayerName }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
